import futureBabyChange from './actions/futureBabyChange';
import futureBabyCreate from './actions/futureBabyCreate';
import futureBabyDetail from './actions/futureBabyDetail';
import futureBabyList from './actions/futureBabyList';
import getFutureBaby from './getters/getFutureBaby';
import futureBabyUpload from './mutations/futureBabyUpload';

const actions = {
    futureBabyChange,
    futureBabyCreate,
    futureBabyDetail,
    futureBabyList
};

const mutations = {
    futureBabyUpload
};

const getters = {
    getFutureBaby
};

export default { actions, mutations, getters };
